import { Modal } from 'antd';
import { observer } from 'mobx-react-lite';
import RoundedButton from './RoundedButton';
import { CiCircleInfo } from 'react-icons/ci';
import { IoCloseOutline } from 'react-icons/io5';
import Button from './Button';

const DeleteModel = observer(({ isOpen, onClose, onConfirm, name }) => {
    return (
        <Modal
            width={500}
            open={isOpen}
            onOk={onConfirm}
            onCancel={onClose}
            footer={null}
            centered
            styles={{
                content: {
                    padding: '32px',
                },
            }}
            closeIcon={<IoCloseOutline className="text-[24px]" />}>
            <div>
                <div className="flex items-center gap-[16px]">
                    <RoundedButton
                        icon={
                            <CiCircleInfo
                                size={30}
                                className="rotate-180 text-[#EF4444]"
                            />
                        }
                        disabled={true}
                        className="!w-[64px] !h-[64px] pointer-events-none !bg-[#EF444430]"
                    />
                    <h1 className="font-favorit text-[24px] font-[600] leading-[32px]">
                        Are you sure you want to <br /> remove {name}?
                    </h1>
                </div>
                <p className="font-favorit text-[16px] font-[400] leading-[24px] mt-[16px]">
                    This action is permanent and cannot be undone.
                </p>
                <div className="grid grid-cols-2 gap-[8px] mt-[24px]">
                    <Button
                        label={'Cancel'}
                        className={
                            'bg-theme-header-bg text-theme-black text-[16px] w-full flex justify-center items-center'
                        }
                        onClick={onClose}
                    />
                    <Button
                        label={'Remove'}
                        className={
                            '!bg-theme-orange text-theme-white hover:!bg-theme-orange-hover  text-[16px] w-full flex justify-center items-center'
                        }
                        onClick={onConfirm}
                    />
                </div>
            </div>
        </Modal>
    );
});

export default DeleteModel;
